{
  "steplist": "Seznam kroků"
}
